import React from 'react';
import usePageData from '../helpers/usePageData';
import '../css/decouvrir.css';

const ProjetOrientationP1 = () => {
    const { data: pageData, loading } = usePageData('projet-p1');

    if (loading || !pageData) return null;

    return (
        <div className="decouvrir-macte">
            {/* Hero Section */}
            <div className="home-hero position-relative w-100 overflow-hidden pt-5" style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)', minHeight: '50vh' }}>
                <div className="position-absolute top-0 start-0 end-0 bottom-0 d-flex flex-column justify-content-center align-items-center text-white z-index-2 px-4 text-center">
                    <h1 className="display-4 fw-bold mb-4 lh-sm" style={{ textShadow: "1px 1px 3px rgba(0,0,0,0.3)" }}>
                        {pageData.hero.title.includes('MACTe') ? (
                            <>{pageData.hero.title.split('MACTe')[0]}<span className="text-warning">MACTe</span>{pageData.hero.title.split('MACTe')[1]}</>
                        ) : pageData.hero.title}
                    </h1>

                    <p className="fs-4 mx-auto mb-4 fw-light" style={{ maxWidth: "800px" }}>
                        {pageData.hero.subtitle}
                    </p>
                </div>
            </div>

            {/* Content Sections */}
            <section className="py-5 bg-white">
                <div className="container py-3">
                    <div className="row">
                        <div className="col-12">
                            {pageData.sections.map((section, index) => (
                                <div key={index}>
                                    {section.title && (
                                        <h2 className="display-5 fw-bold mb-4 mt-5">{section.title}</h2>
                                    )}
                                    {section.content && (
                                        <p className="fs-5 text-muted mb-5">{section.content}</p>
                                    )}
                                    {section.list && (
                                        <ul className="fs-5 text-muted mb-5 list-unstyled">
                                            {section.list.map((item, i) => (
                                                <li key={i} className="mb-2" dangerouslySetInnerHTML={{ __html: item.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>') }} />
                                            ))}
                                        </ul>
                                    )}
                                    {section.paragraphs && (
                                        <div className="fs-5 text-muted">
                                            {section.paragraphs.map((p, i) => (
                                                <p key={i}>{p}</p>
                                            ))}
                                        </div>
                                    )}
                                    {section.blockquote && (
                                        <blockquote className="blockquote bg-light p-4 rounded border-start border-warning border-4 mb-4">
                                            <p className="fst-italic fs-4">{section.blockquote}</p>
                                            {section.blockquoteAuthor && (
                                                <footer className="blockquote-footer">{section.blockquoteAuthor}</footer>
                                            )}
                                        </blockquote>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ProjetOrientationP1;
